import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { clientQuery } from 'Core/data/GraphQLApi';
import { endpoints } from 'Core/defaultValues';
import { range } from "lodash";
import moment from "moment";

const INIT_STATE = {
    loading: false,
    openModal: false,
    result: null,
    data: null
};


const route = "devices/.components/maintenanceWarnings/.components/detailedList/redux/slice";

export const maintenanceWarningsSearchDetailList = createAsyncThunk("devices/maintenanceWarnings/detailedList/searchMaintenanceWarningEvents", async (payload, { rejectWithValue, dispatch }) => {
    try {
        const { unitId, warning, dateRange } = payload
        let response = await clientQuery(`
            query searchMaintenanceWarningEvents($conditions: [MaintenanceWarningEventSearchInput], $sort: [MaintenanceWarningEventSortInput], $limit: Int, $offset: Int) {
                result: searchMaintenanceWarningEvents(conditions: $conditions, sort: $sort, limit: $limit, offset: $offset) {
                    items {
                        id
                        unitId
                        unitTime
                        unit {
                            label
                            timezone
                        }
                        unitTime
                        warning
                        value
                        details
                        createdOn
                        updatedOn
                    }
                    total
                }
            }
            `,
            {
                conditions: [
                    {
                        fields: ["unitId"],
                        terms: [unitId],
                        exact: true,
                        conditionOperator: "AND"
                    },
                    {
                        fields: ["warning"],
                        terms: [warning],
                        exact: true,
                        conditionOperator: "AND"
                    },
                    {
                        range: {
                            fields: ["unitTime"],
                            GTE: moment(moment(dateRange.start).format("YYYY-MM-DD") + " 00:00:00").utc().format("YYYY-MM-DDTHH:mm:ss.sss") + "Z",
                            LTE: moment(moment(dateRange.end).format("YYYY-MM-DD") + " 23:59:59").utc().format("YYYY-MM-DDTHH:mm:ss.sss") + "Z"
                        },
                    }
                ],
                limit: 200,
                offset: 0
            },
            endpoints.GRAPHQL_GENERAL
        )
        return response.result

    } catch (exc) {
        console.log(exc)
        // ALWAYS RETURN ACTION
        ExceptionManager(exc, route, 'maintenanceWarningsSearchDetailList');
        return rejectWithValue(exc);
    }
}
)


export const maintenanceWarningsDetailedListRedux = createSlice({
    name: 'devices/maintenanceWarnings/detailedList',
    initialState: INIT_STATE,
    reducers: {
        reset(state, action) {
            return action.payload ? { ...state, ...action.payload } : { ...INIT_STATE }
        },
        openModalDetailedList(state, action) {
            state.openModal = true
            state.data = action.payload
        }
    },
    extraReducers: (builder) => {

        //maintenanceCreateDriverTask
        builder.addCase(maintenanceWarningsSearchDetailList.pending, (state, action) => {
            state.loading = true
        });

        builder.addCase(maintenanceWarningsSearchDetailList.fulfilled, (state, action) => {
            state.result = action.payload
            state.loading = false;
        });

        builder.addCase(maintenanceWarningsSearchDetailList.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        });
    }
})

const { actions, reducer } = maintenanceWarningsDetailedListRedux;

// Extract and export each action creator by name
export const {
    reset,
    openModalDetailedList
} = actions;

export default reducer;
